import momemt from 'moment';

jQuery( document ).ready(function($) {

  // bio
  $('.all-bio').click(function(e){
    e.preventDefault()
    $('.bio').toggleClass('all')
    if($('.all-bio').html() === 'View more'){
      $('.all-bio').html('View less')
    } else {
      $('.all-bio').html('View more')
    }
  })

  // EVENTS
  $.ajax( {
    url: 'https://rest.bandsintown.com/artists/Old%20Dominion/events?app_id=45PRESS_OLD_DOMINION',
    method: 'GET',
    dataType: 'json',
    error: () => {
      alert( 'Error fetching events!' );
    },
    success: data => {
    const events = $( '#events' );
    let html = '';
    if ( data.length ) {
      for ( let event of data ) {
        let location = event.venue.city + ', ' + event.venue.region;
        if ( location === ', ' ) {location = '';}
        if ( event.venue.name.toLowerCase() === 'streaming live' ) {location = 'Online';}
        html += '<div class="event">';
        html += '<div class="event-date">' + momemt( event.datetime ).format( 'MMM D' ) + '</div>';
        html += '<div class="event-location">' + location + '</div>';
        html += '<div class="event-venue">' + event.venue.name + '</div>';
        html += '<div class="event-links">';
        for ( let offer of event.offers ) {
          html += '<a href="' + offer.url + '" target="_blank" class="btn btn-wine btn-small">' + offer.type + '</a>';
        }
        html += '</div>';
        html += '</div>';
      }
      events.html( html );
      } else {
        events.html( 'No upcoming events.' );
      }
    }
  });

  $('.test-popup-link').magnificPopup({
    type: 'image'
    // other options
  });

  // animation
  AOS.init({
    once: true,
    duration: 1000,
  });

});